const Player = require('@/tbs/model/to/Player')
const player = new Player

/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_Player = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Player.prototype = {
    /* The view object name */
    name: 'player',
    /* The view object instance */
    view: {
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateBMMatchTeamPlayer',
            basePath: '',
            rule: {
                matchId: 'matchGroupId',
                id: 'teamId',
                trueName: 'name',
                avatar: 'logoUrl',
                number: 'num',
                gender: '$gender'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateBMMatchTeamPlayer',
            basePath: '',
            rule: {
                id: 'id',
                matchId: 'matchGroupId',
                trueName: 'name',
                avatar: 'logoUrl',
                number: 'num',
                gender: '$gender'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'DeleteBMMatchTeamPlayer',
            basePath: '',
            rule: {
                id: 'id',
                matchId: 'matchGroupId'
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetBMMatchTeamPlayer',
            basePath: 'data.player',
            rule: {
                id: 'id',
                teamId: 'teamId',
                name: 'trueName',
                logoUrl: 'avatar',
                num: 'number',
                gender: 'gender',
                genderLabel: '$gender'
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    genderOptions: [
        { label: player.localeProp('gender-option-1'), value: '1'},
        { label: player.localeProp('gender-option-2'), value: '2'}
    ],
    genderDefaultValue: '1',
    renderGenderLabel: function(playerGender) {
        if (!playerGender) {
            playerGender = this.genderDefaultValue
        }
        for (let i = 0; i < this.genderOptions.length; i++) {
            let genderOption = this.genderOptions[i]
            if (playerGender == genderOption.value) {
                return genderOption.label
            }
        }
    },
    formatGender: function(gender) {
        if (gender) {
            return gender
        }
        else {
            return this.genderDefaultValue
        }
    }
}

module.exports = tbs_model_vo_Player